import { Box } from '@material-ui/core'
import dynamic from 'next/dynamic'
const MessengerCustomerChat = dynamic(() => import('react-messenger-customer-chat'))

const Messenger = () => {

  return (
      <MessengerCustomerChat
        pageId="842964855757927"
        appId="667610243931493"
      />
  )
}

export default Messenger
